import withRoles from 'HOC/withRoles';
import Users from './Users';
import ChangePassword from './ChangePassword';

export { ChangePassword };
export default withRoles('ROLE_ADMIN')(Users);
